var map = {
	"./stain-01.png": 7823,
	"./stain-02.png": 59734,
	"./stain-03.png": 24036,
	"./stain-04.png": 56234,
	"./stain-05.png": 11959,
	"./stain-06.png": 65563,
	"./stain-07.png": 79155,
	"./stain-08.png": 97537,
	"./stain-09.png": 12269,
	"./stain-10.png": 41314,
	"./stain-11.png": 31679,
	"./stain-12.png": 89634,
	"./stain-13.png": 22352,
	"./stain-14.png": 18793,
	"./stain-15.png": 93437,
	"./stain-16.png": 8640,
	"./stain-17.png": 93718,
	"./stain-18.png": 71129,
	"./stain-19.png": 23442,
	"./stain-20.png": 59825,
	"./stain-21.png": 1613,
	"./stain-22.png": 96988,
	"./stain-23.png": 21930,
	"./stain-24.png": 79890,
	"./stain-25.png": 1573,
	"./stain-26.png": 7213,
	"./stain-27.png": 74656,
	"./stain-28.png": 31314,
	"./stain-29.png": 95540,
	"./stain-30.png": 20064,
	"./stain-31.png": 1724,
	"./stain-32.png": 33234,
	"./stain-33.png": 34446,
	"./stain-34.png": 60209,
	"./stain-35.png": 82564,
	"./stain-36.png": 45835,
	"./stain-37.png": 51369,
	"./stain-38.png": 95918,
	"./stain-39.png": 51594,
	"./stain-40.png": 12756,
	"./stain-41.png": 29474,
	"./stain-42.png": 8194,
	"./stain-43.png": 37277,
	"./stain-44.png": 8006,
	"./stain-45.png": 17915,
	"./stain-46.png": 53705,
	"./stain-47.png": 73646,
	"./stain-48.png": 55388
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43863;